import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IPOSEntryModeFormMeta {
  // POS Entry Mode Code
  cardDataEntryCapability: FormInputMeta;
  operatingEnvironment: FormInputMeta;
  cardHolderAuthenticationCapability: FormInputMeta;
  cardHolderPresenceIndicator: FormInputMeta;
  cardCaptureCapability: FormInputMeta;
  cardDataInput: FormInputMeta;
  cardRewriteCapability: FormInputMeta;
  cardHolderAuthenticationM: FormInputMeta;
  cardPresenceIndicator: FormInputMeta;
  cardHolderAuthenticationE: FormInputMeta;
  pinEntryCapability: FormInputMeta;
  catLevelIndicator: FormInputMeta;
  // ECommerce
  certificateSerialNumber: FormInputMeta;
  xidSetUniqueTransaction: FormInputMeta;
  eCommerceCertificateQuality: FormInputMeta;
  cardHolderCertificateHash: FormInputMeta;
  eCommerceSecurityLevelIndicator: FormInputMeta;
  // Address verification
  addressVerificationRequestOption: FormInputMeta;
  addressVerificationResponse : FormInputMeta;
  // CVV Data
  cvvChangesUsedInFraudMonitoring: FormInputMeta;
  cvvVerificationResponse : FormInputMeta;
  cvvTrackEditError: FormInputMeta;
  

  schema: any;
}

const POSEntryModeFormMeta = {} as IPOSEntryModeFormMeta;
// POS Entry Mode Code
POSEntryModeFormMeta.cardDataEntryCapability = {
  name: 'cardDataEntryCapability',
  type: 'text',
  label: 'Carte capacité de saisie des données',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
POSEntryModeFormMeta.operatingEnvironment = {
  name: 'operatingEnvironment',
  type: 'text',
  label: 'Environnement opérationnel',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
POSEntryModeFormMeta.cardHolderAuthenticationCapability = {
  name: 'cardHolderAuthenticationCapability',
  type: 'text',
  label: 'Capacité d\'authentification du titulaire de la carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
POSEntryModeFormMeta.cardHolderPresenceIndicator = {
  name: 'cardHolderPresenceIndicator',
  type: 'text',
  label: 'Indicateur de présence du titulaire de la carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
POSEntryModeFormMeta.cardCaptureCapability = {
  name: 'cardCaptureCapability',
  type: 'text',
  label: 'Capacité de capture de la carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
},
POSEntryModeFormMeta.cardDataInput = {
  name: 'cardDataInput',
  type: 'text',
  label: 'Carte de saisie de données',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cardRewriteCapability = {
  name: 'cardRewriteCapability',
  type: 'text',
  label: 'Capacité de réécriture de la carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cardHolderAuthenticationM = {
  name: 'cardHolderAuthenticationM',
  type: 'text',
  label: 'Authentification du titulaire de carte M.',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cardPresenceIndicator = {
  name: 'cardPresenceIndicator',
  type: 'text',
  label: 'Indicateur de présence de carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cardHolderAuthenticationE = {
  name: 'cardHolderAuthenticationE',
  type: 'text',
  label: 'Authentification du titulaire de carte E.',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.pinEntryCapability = {
  name: 'pinEntryCapability',
  type: 'text',
  label: 'Capacité de saisie du code PIN',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.catLevelIndicator = {
  name: 'catLevelIndicator',
  type: 'text',
  label: 'Indicateur de niveau CAT',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// ECommerce
POSEntryModeFormMeta.certificateSerialNumber = {
  name: 'certificateSerialNumber',
  type: 'text',
  label: 'Certificat Numéro de série',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.xidSetUniqueTransaction = {
  name: 'xidSetUniqueTransaction',
  type: 'text',
  label: 'Ensemble XID transaction unique',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.eCommerceCertificateQuality = {
  name: 'eCommerceCertificateQuality',
  type: 'text',
  label: 'Qualité du certificat de eCommerce',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cardHolderCertificateHash = {
  name: 'cardHolderCertificateHash',
  type: 'text',
  label: 'Hachage du certificat du titulaire de la carte',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.eCommerceSecurityLevelIndicator = {
  name: 'eCommerceSecurityLevelIndicator',
  type: 'text',
  label: 'Indicateur de niveau de sécurité du eCommerce',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// Address verification
POSEntryModeFormMeta.addressVerificationRequestOption = {
  name: 'addressVerificationRequestOption',
  type: 'text',
  label: 'Option de demande de vérification de l\'adresse',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.addressVerificationResponse = {
  name: 'addressVerificationResponse',
  type: 'text',
  label: 'Réponse de vérification de l\'adresse',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}

// CVV Data
POSEntryModeFormMeta.cvvChangesUsedInFraudMonitoring = {
  name: 'cvvChangesUsedInFraudMonitoring',
  type: 'text',
  label: 'Changements de CVV utilisés dans la surveillance de la fraude',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cvvVerificationResponse = {
  name: 'cvvVerificationResponse',
  type: 'text',
  label: 'Réponse à la vérification du CVV',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}
POSEntryModeFormMeta.cvvTrackEditError = {
  name: 'cvvTrackEditError',
  type: 'text',
  label: 'Erreur d\'édition de la piste CVV',
  placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
}


POSEntryModeFormMeta.schema = yup.object().shape(getValidationSchema(POSEntryModeFormMeta));

export default POSEntryModeFormMeta;